export const getAnchorId = (id: string) => {
  const removeSpecialCharacters = id.replace(/[^a-zA-Z0-9\s]+/g, '');
  return removeSpecialCharacters.replace(/ /g, '-').toLowerCase();
};

